/** Initials = first letters of up to 2 words (split on space/hyphen), uppercased. */
export const initialsOf = (name: string): string =>
  String(name || '')
    .split(/[\s-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w.charAt(0).toUpperCase())
    .join('');
